import axios from 'axios';
import toCamelCase from '../utils/camelCase';
import getExpConfig from '../utils/getExpConfig';
import { recordApiResponse, REMOVE_UPLOAD_IMAGE } from '../utils/newRelic';

export const removeImagesFromS3 = (params) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/deletelogo`;

  const promise = axios.post(url, params);
  return recordApiResponse(promise, REMOVE_UPLOAD_IMAGE, url, params)
    .then((response) => toCamelCase(response))
    .catch((error) => error);
};
